var _defs, _path, _path2, _path3, _path4, _circle, _path5, _polygon, _path6, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildcaredisqualification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.27,20.5H104.5l-.23,47.33a2.5,2.5,0,0,1-2.49,2.49L48,70.39V222.77A12.74,12.74,0,0,0,60.73,235.5H195.27A12.74,12.74,0,0,0,208,222.77V33.23A12.74,12.74,0,0,0,195.27,20.5ZM172.1,139.06,170,152.82a6.26,6.26,0,0,1-6.07,5.21h-9.78l-17.55,10L153,177.44a9.28,9.28,0,0,1,13.39,8.34A9.3,9.3,0,1,1,149.11,181l-17.56-10L114,181a9.2,9.2,0,0,1,1.34,4.79,9.3,9.3,0,1,1-9.3-9.3,9.19,9.19,0,0,1,4.09,1l16.39-9.37L109,158h-8.49a6.26,6.26,0,0,1-6.07-5.21l-2.11-13.76c0-.13,0-.26,0-.39a1.83,1.83,0,0,1-.07-.32c-.07-.67-2-16.37-16.71-16.37a2.5,2.5,0,0,1,0-5C88,117,94,126,96.19,133.23a5.43,5.43,0,0,1,1.22-.14H126l-8.11-36.92a2.5,2.5,0,0,1,3.57-2.77c9,4.54,15.51,1.52,20.26-.68A22.85,22.85,0,0,1,146.08,91l.12,0h.18a1.63,1.63,0,0,1,.31,0h.24l.24,0,.31.08h.13l0,0,.24.11.15.08.06,0,.14.1.21.17,0,0a.46.46,0,0,0,.07.07,2.42,2.42,0,0,1,.25.31l0,0a2.35,2.35,0,0,1,.35.75c2.44,8.94,9.83,11.65,15.23,13.63a25.9,25.9,0,0,1,3.94,1.67s0,0,0,0a1.44,1.44,0,0,1,.25.18,1.67,1.67,0,0,1,.16.12l.15.17c.05,0,.11.1.15.15a2.52,2.52,0,0,1,.65,2.7,30,30,0,0,0,1.82,24.22,2.25,2.25,0,0,1,.27.62A5.33,5.33,0,0,1,172.1,139.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.38,97.92l-12,31.87-6.61-30.07C131.76,102.13,138.05,99.85,142.38,97.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.88,110.84l-25.79,18,10.82-28.77C150.89,106.5,157.34,109.16,161.88,110.84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.93,133.09H138.74l24.64-17.21A35,35,0,0,0,164.93,133.09Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 157.07,
    cy: 185.78,
    r: 4.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.33,185.78a4.3,4.3,0,1,1-4.3-4.3A4.3,4.3,0,0,1,110.33,185.78Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.07 158.03 131.55 165.19 119.03 158.03 144.07 158.03"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.16,138.3l-2.11,13.76a1.3,1.3,0,0,1-1.13,1H100.47a1.28,1.28,0,0,1-1.13-1L97.23,138.3c0-.11,0-.17,0-.17s.05,0,.17,0H167a.27.27,0,0,1,.17,0S167.18,138.19,167.16,138.3Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.49 23.56 99.28 65.32 52.12 65.39 59.29 59.06 99.49 23.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildcaredisqualification);
export default __webpack_public_path__ + "static/media/childcaredisqualification.2df83a1097d7e55531b8b964a93f3c3a.svg";
export { ForwardRef as ReactComponent };